import { create } from 'zustand';
import type { Day1Mode, Day1Phase } from '../application/resolveDay1Path';

/**
 * Nav liviana para tabs/sidebar.
 * `storePublished`: null = todavía no sabemos (ocultar zona Tienda).
 * Lo escribe el bootstrap del shell (readStorePublished, perfil cacheado) y
 * `useDay1Path` (home_snapshot.storefront.is_public).
 */
type Day1PathNavState = {
  loaded: boolean;
  mode: Day1Mode;
  phase: Day1Phase;
  preferCatalogTab: boolean;
  collapseStorefrontNav: boolean;
  /** null = pending; no pintar menú operativo de Tienda. */
  storePublished: boolean | null;
  setFromPath: (input: {
    mode: Day1Mode;
    phase: Day1Phase;
    preferCatalogTab: boolean;
    collapseStorefrontNav: boolean;
  }) => void;
  setStorePublished: (value: boolean | null) => void;
  reset: () => void;
};

const initial = {
  loaded: false,
  mode: 'operando' as Day1Mode,
  phase: 'done' as Day1Phase,
  preferCatalogTab: false,
  collapseStorefrontNav: false,
  storePublished: null as boolean | null,
};

export const useDay1PathNavStore = create<Day1PathNavState>((set) => ({
  ...initial,
  setFromPath: (input) =>
    set((state) => {
      if (
        state.loaded &&
        state.mode === input.mode &&
        state.phase === input.phase &&
        state.preferCatalogTab === input.preferCatalogTab &&
        state.collapseStorefrontNav === input.collapseStorefrontNav
      ) {
        return state;
      }
      return {
        ...state,
        loaded: true,
        mode: input.mode,
        phase: input.phase,
        preferCatalogTab: input.preferCatalogTab,
        collapseStorefrontNav: input.collapseStorefrontNav,
      };
    }),
  setStorePublished: (value) =>
    set((state) => (state.storePublished === value ? state : { ...state, storePublished: value })),
  reset: () => set({ ...initial }),
}));
